import React from 'react'
import WhatWeDoContent from "../../content/home/whatWeDo.mdx"

import "./homePanel.scss"; 
import { Column, Row } from 'gatsby-theme-carbon';

const whatWeDoPanel =() => {
    return (<React.Fragment>
        <div>
            <div className="homePanel">
                <Row>
                    <Column colLg={4}>
                    <h2 className="h2Top">What we offer</h2>
                    </Column>
                    <Column colLg={6}>
                    <p className="headerText">Tools and resources to build offerings that are usable and delightful for people of all abilities.</p>

                    </Column>
                      
                </Row>
                <WhatWeDoContent />
            </div>
        </div>

    </React.Fragment>
    )
 }
export default whatWeDoPanel;

